import React from "react";
import { formatMetric, formatPct } from "../metrics";
import { Skeleton } from "./Ui";
import SourceTip from "./SourceTip";

export function Delta({ comparison, invert = false, compact = false, title }) {
  if (!comparison) return null;
  const { delta, deltaPct } = comparison;
  const positive = invert ? delta < 0 : delta > 0;
  const negative = invert ? delta > 0 : delta < 0;
  const tone = delta === 0 ? "flat" : positive ? "up" : negative ? "down" : "flat";
  const arrow = delta > 0 ? "↑" : delta < 0 ? "↓" : "→";
  return (
    <span className={`bd-delta bd-delta--${tone} ${compact ? "bd-delta--compact" : ""}`} title={title || `Previous period: ${comparison.previous}`}>
      {arrow} {deltaPct === null ? "new" : formatPct(Math.abs(deltaPct), { sign: false })}
    </span>
  );
}

export function KpiCard({ label, value, format = "number", comparison, hint, metric, sub, loading, onClick, active, accent, tipAlign = "left" }) {
  const Tag = onClick ? "button" : "div";
  return (
    <Tag
      type={onClick ? "button" : undefined}
      className={`bd-kpi ${onClick ? "bd-kpi--clickable" : ""} ${active ? "is-active" : ""}`}
      onClick={onClick}
      style={accent ? { "--kpi-accent": accent } : undefined}
    >
      <div className="bd-kpi__label">
        {label}
        <SourceTip metric={metric} hint={hint} title={label} align={tipAlign} />
      </div>
      {loading ? (
        <Skeleton height={30} width="60%" />
      ) : (
        <div className="bd-kpi__value">{formatMetric(value, format)}</div>
      )}
      <div className="bd-kpi__footer">
        {!loading && comparison ? <Delta comparison={comparison} /> : null}
        {sub && <span className="bd-kpi__sub">{sub}</span>}
      </div>
    </Tag>
  );
}

export function KpiStrip({ kpis, comparison, definitions, loading, subs = {} }) {
  return (
    <div className="bd-kpi-strip">
      {definitions.map((d, i) => (
        <KpiCard
          key={d.key}
          label={d.label}
          hint={d.hint}
          metric={d.metric || d.key}
          value={kpis ? kpis[d.key] : 0}
          format={d.format}
          comparison={comparison ? comparison[d.key] : null}
          loading={loading}
          sub={subs[d.key]}
          tipAlign={(i + 1) % 5 === 0 ? "right" : "left"}
        />
      ))}
    </div>
  );
}

// items: [{ label, value, comparison, invert, metric }]
export function StatList({ items }) {
  return (
    <dl className="bd-stat-list">
      {items.map((it) => (
        <div key={it.label} className="bd-stat-list__row">
          <dt>
            {it.label}
            {it.metric && <SourceTip metric={it.metric} title={it.label} align="left" className="bd-stat-list__tip" />}
          </dt>
          <dd>
            {it.value}
            {it.comparison && <Delta comparison={it.comparison} compact invert={it.invert} />}
          </dd>
        </div>
      ))}
    </dl>
  );
}
